<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-header-left class="corp-actions-title">
    <h2 class="title">Corporate Actions</h2>

    <small *ngIf="_accountId.length > 0">
      <button
        nf-icon-button="danger"
        icon="close-circle-outline"
        class="btn-bare"
        ngbTooltip="Remove Account"
        placement="bottom-right"
        (click)="removeFilters('account')"
      ></button
      >Accounts:
      {{ _accountId.join(', ') }}
    </small>
    <small *ngIf="_issueId != null">
      <button
        nf-icon-button="danger"
        icon="close-circle-outline"
        class="btn-bare"
        ngbTooltip="Remove Issue"
        placement="bottom-right"
        (click)="removeFilters('issue')"
      ></button>
      Issue Id:
      {{ this._issueId }}
    </small>
    <corporate-actions-advanced-options
      (dateRangeSelected)="dateRangeSelected($event)"
    >
    </corporate-actions-advanced-options>
  </nf-grid-wrapper-header-left>
  <ng-grid-wrapper-header-right>
    <button
      nf-button="create"
      (click)="onCreate()"
      [disabled]="isCreateButtonDisabled"
    >
      Create
    </button>
  </ng-grid-wrapper-header-right>
  <!-- <ng-grid-wrapper-header-right>
    <button
      nf-icon-button="secondary"
      ngbTooltip="Filters Modal"
      placement="bottom-right"
      icon="filter"
      (click)="launchFiltersModal()"
      style="margin-left: 8px"
      data-cy="advancedFiltersBtn"
    >
      Open Filters Modal
    </button>
    <hs-applied-filter-counts
      [filterCount]="filterCount"
    ></hs-applied-filter-counts>
  </ng-grid-wrapper-header-right> -->
  <ng-grid-wrapper-header-right>
    <button
      id="clear-all-filters-button"
      nf-icon-button="secondary"
      ngbTooltip="Clear Filters"
      icon="filter-remove"
      (click)="clearFilters()"
      class="filter-button"
      [disabled]="!clearFiltersEnabled"
      placement="bottom-right"
    >
      Clear All Filters
    </button>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content>
    <span *nfLoader="isCorporateActionLoading">
      <nf-table-layout
        [hideTitle]="true"
        [gridOptions]="gridOptions"
        [modules]="gridModules"
        [autoResizeGrid]="false"
        [data]="rowCorporateActionData"
        hideSearch
        hideClearAll
      >
      </nf-table-layout>
    </span>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
